import { SessionStorage } from "./sessionStorage.service";
import { Injectable } from '@angular/core'
export class CACHE_CONSTANT {
    USER_PROFILE:string
    TOKEN: string
};

@Injectable()
export class CacheService {
    remove(key: string) {
        window.sessionStorage.removeItem(key);
    }
    removeAll() {
        window.sessionStorage.clear();
    }
    exist(key: string): boolean {
        return window.sessionStorage.getItem(key) != null;
    }
    get(key: string): any {
        if (!this.exist(key)) {
            return null;
        }
        let data: any = window.sessionStorage.getItem(key);
        try {
            return JSON.parse(data);
        }
        catch (e) {
            return null;
        }
    }
    set(key: string, data: any): any {
        window.sessionStorage.setItem(key, JSON.stringify(data));
    }

    checkUserRight(right:string){
        let user_profile:any=window.sessionStorage.getItem('USER_PROFILE')
        let user_rights:any;
        var result;
        if(user_profile){
            user_rights = user_profile.userRights;
            if(user_rights){
                result =user_rights[right]
            }
        }
        return result;
    }
}